import getApiClient from '@/plugins/api-client'
import { parseFilters } from '@/util/helpers'

export default {
  loadInvites: function () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
      ...this.pagination.getParams(),
    })

    api.get('invites', { params })
      .then(result => {
        this.invites = result.data['hydra:member']
        this.pagination.updateData(result.data)
      })
      .catch(error => {
        this.error = error
      })
  },

  exportInvites: function () {
    const api = getApiClient(this.$store)

    api.get('invites/export', {
      responseType: 'blob',
    })
      .then(result => {
        const url = window.URL.createObjectURL(new Blob([result.data]))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', 'export.csv')
        document.body.appendChild(link)
        link.click()
      })
      .catch(error => {
        console.log(error)
      })
  },
}
